import * as React from "react";

function SvgSettings() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12.613" height="13.079" style={{ marginTop: '-4px' }} fill='#284672 ' viewBox="0 0 16.613 17.079">
            <path id="Icon_material-settings" data-name="Icon material-settings" d="M18.059,12.377a5.888,5.888,0,0,0,0-1.674l1.8-1.409a.431.431,0,0,0,.1-.547L18.256,5.792a.429.429,0,0,0-.521-.188l-2.126.854a6.239,6.239,0,0,0-1.443-.837l-.325-2.263A.416.416,0,0,0,13.422,3H10.007a.416.416,0,0,0-.418.359L9.264,5.622a6.561,6.561,0,0,0-1.443.837L5.694,5.6a.417.417,0,0,0-.521.188L3.465,8.747a.421.421,0,0,0,.1.547L5.37,10.7a6.772,6.772,0,0,0-.06.837,6.772,6.772,0,0,0,.06.837l-1.8,1.409a.431.431,0,0,0-.1.547l1.708,2.955a.429.429,0,0,0,.521.188l2.126-.854a6.239,6.239,0,0,0,1.443.837l.325,2.263a.416.416,0,0,0,.418.359h3.416a.416.416,0,0,0,.418-.359l.325-2.263a6.561,6.561,0,0,0,1.443-.837l2.126.854a.417.417,0,0,0,.521-.188l1.708-2.955a.431.431,0,0,0-.1-.547l-1.8-1.409Zm-6.345,2.152A2.989,2.989,0,1,1,14.7,11.54,2.992,2.992,0,0,1,11.714,14.529Z" transform="translate(-3.406 -3)" fill="#284672 " />
        </svg>

    )
}
export default SvgSettings;


// WEBPACK FOOTER //
// ./src/iconComponents/settingsIcon.js